import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import CreateBranchSerialNumberForm from "../../../components/PMWork/BindContract/CreateBranchSerialNumberForm";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";

export default function AddSubBindingPMServiceContract() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        binding: "ผูกสัญญากับสินค้า",
        machine: "สร้างหมายเลขเครื่องประจำสาขา",
        determine: "กำหนดอายุอุปกรณ์/อะไหล่"
      }
    });
  };

  const handleSubmitBranch = (dataCB) => {
    if (dataCB)
      navigate("/PM_work/bind/create", { state: { ...state, data: dataCB } });
  };

  useEffect(() => handleChangeTab(state?.name || "binding"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta
          name="description"
          content="Add Binding a contract with the product Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="branch" title="ผูกสัญญากับสาขา"></Tab>
          <Tab eventKey="binding" title="ผูกสัญญากับสินค้า"></Tab>
          <Tab eventKey="machine" title="กำหนดหมายเลขเครื่อง">
            {websiteName === "สร้างหมายเลขเครื่องประจำสาขา" && (
              <CreateBranchSerialNumberForm
                onSubmitCallback={handleSubmitBranch}
              />
            )}
          </Tab>
          <Tab eventKey="determine" title="กำหนดอายุอุปกรณ์/อะไหล่"></Tab>
        </Tabs>
      </Container>
    </>
  );
}
